export const REVISION_REQUIRED_CATEGORY = 'Revision required'
export const REVIEW_AND_APPROVE_CATEGORY = 'Review and approve'
export const PENDING_FICTIV_REVIEW_CATEGORY = 'Pending Fictiv review'
export const READY_TO_GO_CATEGORY = 'Ready to go'

export type DfmCategoryType =
    | typeof REVISION_REQUIRED_CATEGORY
    | typeof REVIEW_AND_APPROVE_CATEGORY
    | typeof PENDING_FICTIV_REVIEW_CATEGORY
    | typeof READY_TO_GO_CATEGORY

export const DFM_CATEGORY_SUMMARY: { [key in DfmCategoryType]: string } = {
    [REVISION_REQUIRED_CATEGORY]:
        'Please upload part or drawing revisions according to the DFM provided.',
    [REVIEW_AND_APPROVE_CATEGORY]:
        'The following parts have DFM feedback that requires your approval before Fictiv can proceed.',
    [PENDING_FICTIV_REVIEW_CATEGORY]:
        'A Fictiv engineer will need to provide you with updated manufacturability feedback.',
    [READY_TO_GO_CATEGORY]:
        'All DFM topics have been resolved and the part is ready to proceed.',
}

export const DFM_TAG_CATEGORY_COLORS: {
    [key in DfmCategoryType]: string
} = {
    [REVISION_REQUIRED_CATEGORY]: 'red',
    [REVIEW_AND_APPROVE_CATEGORY]: 'orange',
    [PENDING_FICTIV_REVIEW_CATEGORY]: 'blue',
    [READY_TO_GO_CATEGORY]: 'green',
}

export const DFM_ICON_CATEGORY_COLORS: {
    [key in DfmCategoryType]: string
} = {
    [REVISION_REQUIRED_CATEGORY]: 'error6',
    [REVIEW_AND_APPROVE_CATEGORY]: 'warning6',
    [PENDING_FICTIV_REVIEW_CATEGORY]: 'icon6',
    [READY_TO_GO_CATEGORY]: 'primary6',
}
